import React, { Component } from "react";
import { questionsData, losingData, winningData } from "./game-data";
import { getLocalizations } from "./localization/localization";
import { randomize, getCoordsTop } from "./helpers/helpers";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import classNames from "classnames";

import "./ownItgame.sass";

import Question from "./components/Question";
import Answer from "./components/Answer";
import Progress from "./components/Progress";
import Over from "./components/Over";

export default class OwnItGame extends Component {
  constructor(props) {
    super(props);

    this.gameData = questionsData;
    this.losingData = losingData;
    this.winningData = winningData;

    this.ownGame = React.createRef();

    this.state = {
      question: {
        current: 1,
        all: this.gameData.length,
        data: this.gameData[0],
      },
      answer: {
        option: null,
        result: null,
        data: null,
      },
      progress: {
        money: 0,
        trust: 0,
        fame: 0,
      },
      game: {
        lose: false,
        win: false,
        adText: false,
        overIndex: null,
      },
    };
  }

  componentDidUpdate() {
    window.scrollTo(0, getCoordsTop(this.ownGame.current));
  }

  optionClickHandler = (index) => {
    const state = { ...this.state };
    const resultsData = state.question.data.options[index];
    const newAnswer = state.answer;

    newAnswer.option = index;
    newAnswer.result = randomize(0, resultsData.length - 1);
    newAnswer.data = resultsData[newAnswer.result];

    if (newAnswer.data.lose) {
      const newGame = state.game;
      newGame.lose = true;
      newGame.adText = true;
      newGame.overIndex = randomize(0, this.losingData.length - 1);
      this.setState({
        answer: newAnswer,
        game: newGame,
      });
    } else if (newAnswer.data.progress !== undefined) {
      const progress = state.progress;
      progress.money += newAnswer.data.progress.money;
      progress.trust += newAnswer.data.progress.trust;
      progress.fame += newAnswer.data.progress.fame;
      this.setState({
        answer: newAnswer,
        progress: progress,
      });
    }
  };

  nextQuestionHandler = () => {
    const state = { ...this.state };
    const newQuestion = state.question;
    const resetResult = state.answer;

    newQuestion.current = state.question.current + 1;

    if (newQuestion.current > newQuestion.all) {
      const newGame = state.game;
      const { fame, money, trust } = state.progress;
      if (
        (money < 0 && trust >= 0 && fame >= 0) ||
        (trust < 0 && money >= 0 && fame >= 0) ||
        (fame < 0 && money >= 0 && trust >= 0)
      ) {
        newGame.win = true;
        newGame.overIndex = 0;
      } else if (money >= 5 && trust >= 5 && fame >= 5) {
        newGame.win = true;
        newGame.overIndex = 2;
      } else if (money >= 0 && trust >= 0 && fame >= 0) {
        newGame.win = true;
        newGame.overIndex = 1;
      } else {
        newGame.lose = true;
        newGame.overIndex = randomize(0, this.losingData.length - 1);
      }

      this.setState({
        game: newGame,
      });
    } else {
      newQuestion.data = this.gameData[newQuestion.current - 1];

      resetResult.option = null;
      resetResult.result = null;

      this.setState({
        question: newQuestion,
        answer: resetResult,
      });
    }
  };

  resetGame = () => {
    const state = { ...this.state },
      question = state.question,
      answer = state.answer,
      progress = state.progress,
      game = state.game;

    question.current = 1;
    question.data = this.gameData[0];

    answer.option = null;
    answer.result = null;
    answer.data = null;

    progress.money = 0;
    progress.trust = 0;
    progress.fame = 0;

    game.lose = false;
    game.win = false;
    game.adText = false;
    game.overIndex = null;

    this.setState({
      question: question,
      answer: answer,
      progress: progress,
      game: game,
    });
  };

  render() {
    const lang = getLocalizations()[this.props.lang] ? this.props.lang : "ru";
    const dictionary = getLocalizations()[lang];

    const { question, answer, game, progress } = this.state;

    return (
      <div
        className={classNames("own-it__game", {
          "is-won": game.win,
          "is-lost": game.lose,
        })}
        ref={this.ownGame}
      >
        <TransitionGroup component={null}>
          {(() => {
            if (!game.lose && !game.win && question.current <= question.all) {
              if (answer.option === null) {
                return (
                  <CSSTransition
                    key="question"
                    in={true}
                    classNames="switch"
                    timeout={{ enter: 200, exit: 0 }}
                  >
                    <Question
                      question={question}
                      dictionary={dictionary}
                      click={this.optionClickHandler}
                      progress={
                        <Progress
                          type="horizontal"
                          data={progress}
                          dictionary={dictionary}
                        />
                      }
                    />
                  </CSSTransition>
                );
              } else if (answer.option !== null && answer.result !== null) {
                return (
                  <CSSTransition
                    key="answer"
                    in={true}
                    classNames="switch"
                    timeout={{ enter: 200, exit: 0 }}
                  >
                    <Answer
                      question={question}
                      answer={answer}
                      dictionary={dictionary}
                      click={this.nextQuestionHandler}
                      progress={
                        <Progress
                          type="horizontal"
                          data={progress}
                          answer={answer.data.progress}
                          dictionary={dictionary}
                        />
                      }
                    />
                  </CSSTransition>
                );
              } else {
                return null;
              }
            } else if (game.lose || game.win) {
              return (
                <CSSTransition
                  key="over"
                  in={true}
                  classNames="switch"
                  timeout={{ enter: 200, exit: 0 }}
                >
                  <Over
                    dictionary={dictionary}
                    answer={answer}
                    question={question}
                    game={game}
                    click={this.resetGame}
                    progress={
                      <Progress
                        type="vertical"
                        data={progress}
                        dictionary={dictionary}
                      />
                    }
                  />
                </CSSTransition>
              );
            } else {
              return null;
            }
          })()}
        </TransitionGroup>
      </div>
    );
  }
}
